export default "__VITE_ASSET__Bvzp_qT9__"